<template>
  <div>
    <v-navigation-drawer app height="100%" color="#f1efed" v-model="drawer">
      <v-list class="pt-0 mt-0">
        <v-list-item class="gold" two-line>
          <span class="mx-auto">
            <a href="https://www.adelphi.edu" title="Adelphi University">
              <v-img
                src="../assets/adelphi-logo.png"
                alt="Adelphi University"
                class="shrink mr-2"
                max-width="150"
                contain
              />
            </a>
          </span>
        </v-list-item>

        <v-list-item class="px-8" link>
          <v-list-item-content>
            <v-list-item-title class="title"> My Profile </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="mx-8"></v-divider>

        <v-list-item
          dense
          link
          class="px-8"
          v-for="item in get_nav_items(this.pto_access, this.isFaculty)"
          :key="item.title"
          router
          :to="item.route"
        >
          <v-list-item-icon
            v-if="showPtoBadge && item.icon == 'mdi-calendar-star'"
          >
            <v-badge color="pink" dot left overlap
              ><v-icon>{{ item.icon }}</v-icon></v-badge
            >
          </v-list-item-icon>
          <v-list-item-icon v-else>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- Top Nav -->

    <v-app-bar
      v-if="$vuetify.breakpoint.mdAndDown"
      app
      color="#ffb500"
      class="hidden-lg-and-up"
      flat
      @click="drawer = !drawer"
    >
      <v-app-bar-nav-icon class="ml-5"></v-app-bar-nav-icon>
      <div>
        <a href="https://www.adelphi.edu">
          <v-img
            src="../assets/adelphi-logo.png"
            alt="Adelphi University"
            class="shrink mr-2"
            max-width="160"
            contain
          />
        </a>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import axios from "axios";
import pto_func from "@/pto_functions";

export default {
  data() {
    return {
      selectedItem: 0,
      drawer: false,
      nav_items: [
        {
          title: "Professional Info",
          icon: "mdi-bank",
          route: "/professional",
          action: ""
        },
        { title: "Personal Record", icon: "mdi-account", route: "/personal" },
        {
          title: "Paid Time-Off",
          icon: "mdi-calendar-star",
          route: "/pto",
          action: "pto_request"
        },
        {
          title: "My Benefits",
          icon: "mdi-cards-heart",
          route: "/benefits",
          action: ""
        },
        {
          title: "Total Benefits",
          icon: "mdi-chart-pie",
          route: "/totals",
          action: ""
        },
      ],
      showPtoBadge: false,
      pto_access: "N",
      isFaculty: "N",
      //test: this.getTest(),
    };
  },
  created() {
    axios.get("./remote-apis/pto_api.php?cmd=pto_pc").then((response) => {
      this.pc = response.data;
      if (this.pc.response == 0) {
        this.showPtoBadge = pto_func.get_badge_status(
          "pto",
          this.pc.pending_confirmed,
          this.pc.pending_mgr_approval
        );
        this.pto_access = this.pc.pto_access;
        this.isFaculty = this.pc.is_faculty;
      }
    });

  },
  mounted() {
    this.drawer = this.$vuetify.breakpoint.width >= 1264 ? true : false;
  },
  
  methods: {
    get_nav_items(pto_access, isFaculty) {
      var res = [];
      var nav_items = this.nav_items;
      for (var i = 0; i < nav_items.length; i++) {
          if (nav_items[i]['title'] == "Paid Time-Off") {
            if (pto_access == "Y") {
              if (isFaculty == "Y")
                nav_items[i]['route'] = "/pto/manager";
              res.push(nav_items[i]);
            } else if (pto_access == "U") {
                nav_items[i]['route'] = "/time-off";
                res.push(nav_items[i]);
            }
          } else {
            res.push(nav_items[i]);
          }          
      }
      return res;  
    }
  } 
};
</script>
